// General Helper
// TODO: refactor ternaries and remove this rule

/* eslint-disable no-nested-ternary */
import moment from 'moment';
import { get, chunk } from 'lodash';
import setUpSchedule from "./initializeHelpers/setUpSchedule";
import getAvailMatch from "./initializeHelpers/getAvailMatch";
import clientEmailTemplate from "./initializeHelpers/emailTemplates/clientEmailTemplate";
export const getCountryId = (data, countryId) => {
  const address = data.find(el => el.countryId === countryId);
  const result = !!address && !!address.internationalNumbers && !!address.internationalNumbers.length || !!address && !!address.tollFreeNumbers && !!address.tollFreeNumbers.length ? countryId : 219;
  return result;
};
export const formatZoomMeetingId = zoomMeetingId => {
  const zoomMeetingIdNumberArray = [...String(zoomMeetingId)];
  const zoomMeetingNumberGroups = chunk(zoomMeetingIdNumberArray, 3);
  return `${zoomMeetingNumberGroups.map(group => group.join('')).join('-')}#`;
}; // TODO: rewrite this

export const getInitialStates = (availabilityStore, firstMatch, multipleExperts, eplModel, showAddExpert, multiAction) => {
  var _availabilityStore$us, _availabilityStore$us2, _availabilityStore$us3, _availabilityStore$us4, _availabilityStore$of, _availabilityStore$of2, _availabilityStore$of3, _availabilityStore$sc;

  const expertPosition = get(availabilityStore.epl, 'relevantExperience.experience.position.name', '');
  const expertCompany = get(availabilityStore.epl, 'relevantExperience.experience.company.name', '');
  const expertLocation = get(availabilityStore.epl, 'relevantExperience.experience.location', '');
  const relevantSegment = get(availabilityStore.epl, 'segment.name', '');
  const updatedSchedule = setUpSchedule(availabilityStore, firstMatch);
  const result = updatedSchedule.result;
  const employeePositionId = (_availabilityStore$us = availabilityStore.userStore.user) === null || _availabilityStore$us === void 0 ? void 0 : (_availabilityStore$us2 = _availabilityStore$us.currentPosition) === null || _availabilityStore$us2 === void 0 ? void 0 : _availabilityStore$us2.employeePositionId;
  const userPosition = availabilityStore.staticData.names.employeePositions[employeePositionId] || '';
  const userPhones = ((_availabilityStore$us3 = availabilityStore.userStore.user) === null || _availabilityStore$us3 === void 0 ? void 0 : (_availabilityStore$us4 = _availabilityStore$us3.address) === null || _availabilityStore$us4 === void 0 ? void 0 : _availabilityStore$us4.phones) || [];
  const userPhoneNumbers = userPhones.map(phone => phone.phoneNum);
  const clientTitle = availabilityStore.project.clients.map(client => `${client.title} ${client.fullName}`).join(', ');
  const clientMap = result.availabilities.filter(({
    type
  }) => type === 'client').map(avail => {
    return {
      start: avail.time.start,
      end: avail.time.end
    };
  });
  const expertMap = result.availabilities.filter(({
    type
  }) => type === 'expert').map(avail => {
    return {
      start: avail.time.start,
      end: avail.time.end
    };
  });
  const expertInfo = availabilityStore.epl.nameDisclosed ? ` ${availabilityStore.epl.expert.title} ${availabilityStore.epl.expert.fullName || 'Expert'}, ${expertPosition}, ${expertCompany}, ${expertLocation} for Segment: ${relevantSegment}` : ` expert${expertLocation ? ' from ' + expertLocation : ''}, ${expertPosition}, ${expertCompany}, for Segment: ${relevantSegment}`;
  const initFirstMatch = getAvailMatch(clientMap, expertMap, availabilityStore.scheduleRequests);
  const currentPath = getInitialCurrentPath(multipleExperts, result, initFirstMatch);
  const initialPayload = {
    availabilityStore_imp: availabilityStore,
    clientContacts: availabilityStore.project.clients,
    numberOfAdditionalClientEmail: availabilityStore.project.clients.length,
    eplId: availabilityStore.epl.id,
    expertTimezone: availabilityStore.epl.expert.address.timezoneId ? availabilityStore.staticData.timezones.find(tz => tz.id === availabilityStore.epl.expert.address.timezoneId) : availabilityStore.staticData.timezones.find(tz => tz.name === moment.tz.guess()),
    clientTimezone: !!availabilityStore.officeTimezone ? availabilityStore === null || availabilityStore === void 0 ? void 0 : (_availabilityStore$of = availabilityStore.officeTimezone) === null || _availabilityStore$of === void 0 ? void 0 : _availabilityStore$of.offset : '',
    clientZone: {
      timezoneOffset: moment().utcOffset(availabilityStore === null || availabilityStore === void 0 ? void 0 : (_availabilityStore$of2 = availabilityStore.officeTimezone) === null || _availabilityStore$of2 === void 0 ? void 0 : _availabilityStore$of2.offset).utcOffset(),
      displayLabel: 'Client'
    },
    clientTimezoneName: availabilityStore === null || availabilityStore === void 0 ? void 0 : (_availabilityStore$of3 = availabilityStore.officeTimezone) === null || _availabilityStore$of3 === void 0 ? void 0 : _availabilityStore$of3.name,
    expertZone: {
      timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
      displayLabel: 'Expert'
    },
    duration: ((_availabilityStore$sc = availabilityStore.schedule) === null || _availabilityStore$sc === void 0 ? void 0 : _availabilityStore$sc.duration) || initFirstMatch.duration,
    callJoinUrl: availabilityStore.schedule && availabilityStore.schedule.zoomJoinUrl ? availabilityStore.schedule.zoomJoinUrl : 'Url will be created after confirm',
    currentPath,
    zoomTopic: formatZoomTopic(availabilityStore, multiAction || multipleExperts && multipleExperts.length),
    expertSubject: formatInvitationSubject(availabilityStore, multiAction || multipleExperts && multipleExperts.length),
    clientSubject: formatInvitationSubject(availabilityStore, multiAction || multipleExperts && multipleExperts.length),
    clientTitle: availabilityStore.project.clients.map(client => `${client.title} ${client.fullName}`).join(', '),
    clientMessage: clientEmailTemplate(clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers),
    scheduleRequests: availabilityStore.scheduleRequests.filter(req => req !== undefined && new Date(req.startTime).getTime() > new Date().getTime()),
    eplModels: eplModel.eplStore.eplModels.filter(model => model !== undefined && model.epl.eplStatusId === 5 && model.epl.expert.fullName !== availabilityStore.epl.expert.fullName && model.epl.segment.name === availabilityStore.epl.segment.name),
    disableAddAnotherExpert: !showAddExpert,
    sendSmsExpertPhoneNumber: availabilityStore.sendSmsExpertPhoneNumber,
    expertPhoneNumbers: availabilityStore.expertPhoneNumbers.filter(x => x !== undefined),
    sendSmsToPhoneNumberIds: availabilityStore.sendSmsToPhoneNumberIds
  };
  return {
    newStates: {
      expertInfo: expertInfo,
      userPosition: userPosition,
      userPhoneNumbers: userPhoneNumbers,
      ...initialPayload
    },
    updatedSchedule,
    initFirstMatch
  };
}; //If it is reschedule - reuse topic

export const formatZoomTopic = (availabilityStore, hideExpertNameInSubject) => {
  const savedTopic = get(availabilityStore, 'persistedScheduleInfo.zoomMeeting.topic');
  if (savedTopic) return savedTopic;
  return formatInvitationSubject(availabilityStore, hideExpertNameInSubject);
}; //If it is MEM - don't show expert names

export const formatInvitationSubject = (availabilityStore, hideExpertNameInSubject) => {
  const nameDisclosed = get(availabilityStore, 'epl.nameDisclosed');
  let subject = '';

  if (nameDisclosed) {
    subject = `Atheneum: ${availabilityStore.project.projectName} - ${availabilityStore.epl.segment.name}`;

    if (!hideExpertNameInSubject) {
      subject += ` - ${availabilityStore.epl.expert.title} ${availabilityStore.epl.expert.fullName}`;
    }
  } else {
    subject = 'Atheneum call';
  }

  return subject;
}; // Using MEM actions -> "Add Expert" won't forward multipleExperts, "Reschedule" will
// non-MEM case: If EPL was scheduled open Overview, otherwise CalendarView

const getInitialCurrentPath = (multipleExperts, result, initFirstMatch) => {
  if (multipleExperts) return 'calendarview';
  if (!!result.timeslots.length || initFirstMatch.time > 0) return 'overview';
  return 'calendarview';
};